import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ThumbUtil from './../util/ThumbnailUtil';
import StyledTitle from '../hoc/StyledTitle';
import Div from './elements/Div';

import './UserProfileImage.css';
import ToolTip from './AssetPropertyView';

const debug = require('../debug/debug')('wc:common:UserProfileImage');

@StyledTitle
export default class UserProfileImage extends React.Component {
  static propTypes = {
    size: PropTypes.any.isRequired,
    userId: PropTypes.string.isRequired,
    style: PropTypes.object,
    imageUrl: PropTypes.string,
    displayFullname: PropTypes.bool,
    vertical: PropTypes.bool
  };

  constructor(props) {
    super(props);
    let profilePath = this.props.imageUrl || ThumbUtil.avatar(this.props.userId);
    this.state = {
      fullName: '',
      profilePath: profilePath
    };
  }

  componentWillReceiveProps(nextProps) {
    // if (this.props.imageUrl != nextProps.imageUrl) {
    const profilePath = nextProps.imageUrl || ThumbUtil.avatar(nextProps.userId);
    this.setState({ profilePath });
    // }
  }

  async componentDidMount() {
    this._isMounted = true;
    try {
      const fullName = await ThumbUtil.loadUserFullName(this.props.userId);
      if (this._isMounted) {
        this.setState({ fullName });
      }
    } catch (err) {
      debug('[componentDidMount] error: ', err);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  onError = () => {
    const profilePath = 'images/blank_profile_pic.png';
    let userProfileRetryCount = window.gs.userProfileRetryCount;
    this.setState({ profilePath });
    if (!userProfileRetryCount) userProfileRetryCount = 0;
    if (userProfileRetryCount < 3) {
      userProfileRetryCount++;
      window.gs.userProfileRetryCount = userProfileRetryCount;
      setTimeout(() => {
        this.forceUpdate();
      }, 300 * userProfileRetryCount);
    }
  };

  render() {
    const { displayFullname, userId, size, style, vertical } = this.props;
    const { fullName } = this.state;
    return (
      <ToolTip text={fullName}>
        <div className={classNames({ vertical })} style={style} name="UserProfileImage">
          <img
            crossOrigin="use-credentials"
            style={{ maxWidth: size, maxHeight: size, width: size, height: size, objectFit: 'cover' }}
            src={this.state.profilePath}
            //src={imageUrl || ThumbUtil.avatar(userId)}
            onError={this.onError}
          />
          {fullName && displayFullname ? <div>{fullName}</div> : null}
        </div>
      </ToolTip>
    );
  }
}
